import "./index.css"

import { jsx, jsxs } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import classNames from 'classnames';
import { HeadingBlock } from '@design-system/heading-block';
import { Typography } from '@design-system/typography';
import React from 'react';
import { CtaBlock } from '@design-system/cta-block';
import { ExtendableImage } from '@design-system/extendable-image';

const getValidChildren = (children) => React.Children.toArray(children).filter((child) => React.isValidElement(child));
const isReactChildrenValid = (children) => !!React.Children.count(getValidChildren(children));

const CardContent = ({ children, headingBlock, disclaimer, category, }) => (jsx("div", Object.assign({ className: "cds-card__content" }, { children: jsxs("div", Object.assign({ className: "cds-card__content-inner" }, { children: [category ? (jsx(Typography, { className: "cds-card__category", content: category, variant: "body", size: "xs", weight: "regular", align: headingBlock === null || headingBlock === void 0 ? void 0 : headingBlock.align })) : null, jsx(HeadingBlock, Object.assign({}, headingBlock, { className: "cds-card__heading-block" })), isReactChildrenValid(children) || disclaimer ? (jsxs("div", Object.assign({ className: "cds-card__content-bottom" }, { children: [children, disclaimer && (jsx(Typography, { className: "cds-card__disclaimer", variant: "body", size: "xs", tag: "p", content: disclaimer, align: headingBlock === null || headingBlock === void 0 ? void 0 : headingBlock.align }))] }))) : null] })) })));

const CardCTA = ({ ctaBlock }) => (jsx(CtaBlock, Object.assign({}, ctaBlock, { className: "cds-card__cta" })));

const CardLabel = ({ labelContent, srOnlyLabelPrefix, labelVariant, labelSize = 'large', }) => (jsxs("div", Object.assign({ className: classNames('cds-card__label', {
        [`cds-card__label--${labelSize}`]: labelSize,
        [`cds-card__label--${labelVariant}`]: labelVariant,
    }) }, { children: [jsxs("span", Object.assign({ className: "cds-sr-only" }, { children: [srOnlyLabelPrefix, " "] })), labelContent] })));

const CardMedia = ({ image, mediaVariant, children, }) => (jsxs("div", Object.assign({ className: classNames('cds-card__media', {
        [`cds-card__media--variant-${mediaVariant}`]: mediaVariant,
    }) }, { children: [children, image && jsx(ExtendableImage, Object.assign({}, image, { className: "cds-card__media-image" }))] })));

const Card = ({ className, children, variant = 'standard', link, hasMedia, }) => {
    const LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
    return (jsxs("article", Object.assign({ className: classNames('cds-card', {
            [`cds-card--variant-${variant}`]: variant,
            [`cds-card--no-media`]: !hasMedia,
        }, className) }, { children: [children, link ? (jsx(LinkElement, Object.assign({}, link.props, { variant: "wrapper", className: "cds-card__link" }))) : null] })));
};
Card.CardMedia = CardMedia;
Card.CardContent = CardContent;
Card.CardLabel = CardLabel;
Card.CardCTA = CardCTA;

export { Card };
